export default "__VITE_ASSET__199339fb__"